<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="true" />
        </template>

        <translation-billing-form
            id="translation-billing-form"
            v-if="resource"
            :initialFields="resource"
            @submit="handleSubmit"
        />

        <template #footer>
            <x-submit-button
                form="translation-billing-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import TranslationBillingForm from "./TranslationBillingForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import { handleGeneralXhrError, handleValidationXhrError } from "../../helpers";
import XSubmitButton from "../../components/XSubmitButton.vue";

export default {
    components: {
        XPage,
        XBackButton,
        TranslationBillingForm,
        XTable,
        XSubmitButton,
    },
    computed: {
        pageTitle() {
            let title = ["Edit Billing"];

            if (this.resource) {
                title.push(`#${this.resource.id}`);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/translation-billings/${this.$route.params.id}`)
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleSubmit(fields) {
            this.isLoading = true;
            fields.append("_method", "PATCH");
            const request = axios
                .post(`/api/translation-billings/${this.resource.id}`, fields, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `#${response.data.data.id} diupdate!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
};
</script>
